export const BASE_URL = 'http://localhost:8080';
